import { render } from "./app-table.vue?vue&type=template&id=5a98b67c&scoped=true"
import script from "./app-table.vue?vue&type=script&lang=js"
export * from "./app-table.vue?vue&type=script&lang=js"

import "./app-table.vue?vue&type=style&index=0&id=5a98b67c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a98b67c"],['__file',"src/views/components/table/app-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a98b67c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a98b67c', __exports__)) {
    console.log('reload')
    api.reload('5a98b67c', __exports__)
  }
  
  module.hot.accept("./app-table.vue?vue&type=template&id=5a98b67c&scoped=true", () => {
    console.log('re-render')
    api.rerender('5a98b67c', render)
  })

}


export default __exports__